import { Component } from '@poa/core';
import { observable, Observer, toJS } from '@poa/state';
import React from 'react';
import { DateRangePicker } from 'react-dates';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import * as Recharts from 'recharts';
import Dropdown from '../dropdown';

const {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} = Recharts;

export const EntityType = {
  manager: 'manager',
  teamleads: 'teamlead',
  panels: 'panel'
};

class Chart extends React.Component {
  actions; // injected by Poa
  t; // injected by Poa

  focusedDateInput = observable(null);

  handleDatepickerFocusChange = focusedInput => this.focusedDateInput.set(focusedInput);

  render() {
    return (
      <div
        className="authorization__box"
        style={{
          width: 'calc(100% - 100px)',
          minHeight: '480px',
          marginBottom: '50px',
          marginLeft: '50px',
          padding: 25
        }}
      >
        <Observer>
          {() => (
            <Dropdown
              label={'type'}
              selected={this.props.selectedEntityType}
              render={(isOpen, onClose) => (
                <React.Fragment>
                  <button
                    className="common-filter__btn"
                    onClick={() => {
                      this.props.onEntityTypeSelect(EntityType.teamleads);
                      onClose();
                    }}
                  >
                    teamleads
                  </button>
                  <button
                    className="common-filter__btn"
                    onClick={() => {
                      this.props.onEntityTypeSelect(EntityType.manager);
                      onClose();
                    }}
                  >
                    managers
                  </button>
                  <button
                    className="common-filter__btn"
                    onClick={() => {
                      this.props.onEntityTypeSelect(EntityType.panels);
                      onClose();
                    }}
                  >
                    panels
                  </button>
                </React.Fragment>
              )}
            />
          )}
        </Observer>
        <div className="filter">
          <span className="filter__label">{this.t(this.props.selectedEntityType || '-')}</span>
          <Observer>
            {() => (
              <Select
                className="charts-type-select"
                closeOnSelect={false}
                disabled={this.props.selectedEntityType === null}
                multi
                onChange={this.props.onEntitySelect}
                options={this.props.data.entities}
                placeholder={
                  this.props.selectedEntityType === null
                    ? 'Please, select type'
                    : `Select ${this.props.selectedEntityType}`
                }
                removeSelected={true}
                simpleValue
                onClose={this.props.onEntityClose}
                value={this.props.selectedEntityId}
              />
            )}
          </Observer>
        </div>
        <Observer>
          {() => (
            <div className="filter">
              <span className="filter__label">{this.t('period')}</span>
              <DateRangePicker
                startDateId="1"
                endDateId="1"
                isOutsideRange={() => false}
                startDate={this.props.startDate}
                startDatePlaceholderText={this.t('from')}
                endDate={this.props.endDate}
                endDatePlaceholderText={this.t('to')}
                onDatesChange={this.props.onDatesChange}
                focusedInput={this.focusedDateInput.get()}
                onFocusChange={this.handleDatepickerFocusChange}
                customArrowIcon="-"
                minimumNights={0}
                hideKeyboardShortcutsPanel={true}
              />
            </div>
          )}
        </Observer>

        <Observer>
          {() =>
            this.props.data.chartsData ? (
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  // width={500}
                  // height={300}
                  data={toJS(this.props.data.chartsData.data)}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <XAxis dataKey="name" />
                  <YAxis />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Tooltip />
                  <Legend />
                  {Object.keys(this.props.data.chartsData.config).map(dataKey => {
                    const config = this.props.data.chartsData.config[dataKey];

                    return (
                      <Line
                        key={dataKey}
                        type="monotone"
                        dataKey={dataKey}
                        strokeWidth={4}
                        stroke={config.color}
                        // activeDot={{ r: 8 }}
                        name={config.name}
                      />
                    );
                  })}
                </LineChart>
              </ResponsiveContainer>
            ) : null
          }
        </Observer>
        <div
          style={{
            // height: '100px',
            // display: 'flex',
            // alignItems: 'center',
            paddingTop: 25
          }}
        >
          <button type="button" className="filter-columns__save" onClick={this.props.onDelete}>
            Удалить
          </button>
        </div>
      </div>
    );
  }
}

export default Component({ namespaces: ['charts'] })(Chart);
